"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidePane = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const ChevronLeftIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronLeftIcon"));
const ChevronRightIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronRightIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const react_1 = __importStar(require("react"));
const makeMyClasses = (left, stacked, opening, width, color) => ({
    root: {
        flex: '0 0',
        position: 'relative',
        overflow: opening ? 'hidden' : undefined,
        width: opening ? width : 0,
        minWidth: opening ? width : 24,
        transition: stacked ? 'width 0.6s, min-width 0.6s' : undefined,
    },
    label: {
        lineHeight: '24px',
        width: 200,
        textAlign: 'right',
        color: 'white',
        transition: 'color 0.3s',
        transform: 'translate(-100%, 4px) rotate(270deg)',
        transformOrigin: 'right top',
    },
    dots: {
        width: 'fit-content',
        margin: '40px auto 0 auto',
    },
    pane: Object.assign(Object.assign({}, (opening
        ? {
            marginRight: left ? undefined : 0,
            marginLeft: left ? 0 : undefined,
        }
        : {
            marginRight: left ? undefined : 24 - width,
            marginLeft: left ? 24 - width : undefined,
        })), { right: left ? undefined : 0, left: left ? 0 : undefined, position: 'absolute', width: width, minWidth: width, top: 0, bottom: 0, zIndex: 1000, transition: 'margin-left 0.6s, margin-right 0.6s' }),
    inner: {
        backgroundColor: lib_palette_1.default.White.main,
    },
    handle: {
        transition: 'color 0.3s, background-color 0.3s',
        color: color.contrastText,
        backgroundColor: color.main,
        cursor: 'pointer',
        width: '24px',
        borderRight: stacked ? `1px solid white` : undefined,
    },
});
exports.SidePane = react_1.default.memo((props) => {
    const { label, width, stacked = false, startOpen = false, forceClose = false, left = false, padding = false, color = lib_palette_1.default.primary, renderOpen, renderOpening, onChangeOpen, } = props;
    const [opening, setOpening] = (0, react_1.useState)(startOpen);
    const [opened, setOpened] = (0, react_1.useState)(false);
    const myCss = (0, web_css_1.default)(makeMyClasses, [left, stacked, opening, width, color]);
    const handleToggleOpen = (0, react_1.useCallback)(() => {
        setOpening(!opening);
        onChangeOpen === null || onChangeOpen === void 0 ? void 0 : onChangeOpen(!opening);
    }, [onChangeOpen, opening]);
    (0, react_1.useEffect)(() => {
        if (opening && forceClose)
            setOpening(false);
        if (opening && !forceClose)
            setTimeout(() => setOpened(true), 700);
    }, [opening, forceClose]);
    const icon = left ? (opening ? (react_1.default.createElement(ChevronLeftIcon_1.default, { style: { margin: '8px 0' } })) : (react_1.default.createElement(ChevronRightIcon_1.default, { style: { margin: '8px 0' } }))) : opening ? (react_1.default.createElement(ChevronRightIcon_1.default, { style: { margin: '8px 0' } })) : (react_1.default.createElement(ChevronLeftIcon_1.default, { style: { margin: '8px 0' } }));
    return (react_1.default.createElement("div", { className: myCss.root },
        react_1.default.createElement(Horizontal_1.default, { classes: { root: myCss.pane } },
            !!left && (react_1.default.createElement(Pane_1.default, { padding: padding, grow: true, classes: { root: myCss.inner } },
                !opened && renderOpening && renderOpening(),
                !!opened && renderOpen())),
            react_1.default.createElement(Pane_1.default, { classes: { root: myCss.handle }, onClick: handleToggleOpen },
                icon,
                react_1.default.createElement("div", { className: myCss.label },
                    react_1.default.createElement("span", { style: { fontSize: '0.8em' } }, label.toUpperCase()))),
            !left && (react_1.default.createElement(Pane_1.default, { grow: true, classes: { root: myCss.inner } },
                !opened && renderOpening && renderOpening(),
                !!opened && renderOpen())))));
});
exports.default = exports.SidePane;
